module.exports = __webpack_public_path__ + "img/shuixi08.35792fed.png";